/* eslint-disable @typescript-eslint/no-explicit-any */
import { Heading, Text, Button as ButtonC, useToast, VStack, Box, Grid, Image } from '@chakra-ui/react';

import { useEffect, useMemo } from 'react';
import { Button } from '@partiu/ui/components/atoms/Button';
import { useTheme } from '../../../contexts/ThemeProvider';
import { useProfile } from '@partiu/ui/contexts/ProfileProvider';
import { Input } from '../../../components/atoms/Input';
import { useForm } from 'react-hook-form';
import { useMutation } from 'react-query';
import { updateSubscription } from '@partiu/api/club/api';
import { masks } from '@partiu/ui/masks';
import { useNavigate } from 'react-router-dom';

export function Dependents() {
  const { id, getValidSubscriptions, colors } = useTheme();
  const { profile, updateProfile } = useProfile();
  const toast = useToast();

  const methods = useForm<any>();

  const nav = useNavigate();

  const { control, setValue } = methods;

  const extraCPFs = methods.watch('extraCpfs');

  const subscription = useMemo(() => {
    if (!profile) return;
    const subscriptions = getValidSubscriptions(profile);

    return (subscriptions || []).filter((s) => s.plan.agreement.id === id)[0];
  }, [profile, getValidSubscriptions, id]);

  const updateSubscriptionMutation = useMutation(
    () => {
      if (!subscription) return Promise.reject('Subscription is undefined');
      return updateSubscription(subscription.id, { extra_cpfs: extraCPFs });
    },
    {
      onSuccess: function () {
        updateProfile({});
        toast({
          title: 'Sucesso',
          description:
            'Os CPFs foram vinculados com sucesso. Caso não tenham conta, cadastre-se usando a opção CPF Vinculado. Usuários já cadastrados poderão fazer login na plataforma usando a conta com o CPF cadastrado.',
          status: 'success',
        });
      },
      onError: function () {
        toast({ title: 'Oops!', description: 'Um dos CPFs digitados não é válido!', status: 'error' });
      },
    }
  );

  function getDependantText() {
    if (subscription?.plan?.accessAmount === 1)
      return `Seu plano atual não permite a adição de dependentes. Faça um upgrade para que você possa credenciar, além de você, outros dependentes para utilizar a plataforma..`;
    return `Olha que notícia boa! Identificamos que seu combo ${subscription?.plan
      .name} permite que você cadastre mais ${
      (subscription?.plan?.accessAmount ?? 0) - 1
    } CPF(s) para ter acesso gratuito a plataforma. Não perca tempo, cadastre agora.`;
  }

  useEffect(() => {
    if (!subscription) return;

    const newArr = new Array(subscription.plan.accessAmount - 1).fill('');

    subscription.extraCpfs.forEach((cpf, index) => (newArr[index] = masks.cpf(cpf)));

    setValue('extraCpfs', newArr);
  }, [subscription]);

  return (
    <VStack align={'flex-start'} width={'90%'} paddingTop={'20px'}>
      <Grid width={'100%'} templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}>
        <Box
          display={{
            base: 'none',
            md: 'flex',
          }}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Image padding="20px" width={'70%'} marginRight="auto" src="/assets/side-image.png" />
        </Box>

        <VStack
          spacing={5}
          align={{
            base: 'center',
          }}
          width={'100%'}
          maxW={'600px'}
          paddingTop={'20px'}
        >
          <Heading paddingBottom={'10px'}>Seus Dependentes</Heading>
          <Text textAlign={'center'} fontSize={'14px'}>{getDependantText()}</Text>
          <VStack width={'100%'} spacing={2}>
            <form style={{ width: '100%' }}>
              <VStack spacing={2} w={'100%'}>
                {(subscription?.plan?.accessAmount ?? 0) > 1 &&
                  new Array((subscription?.plan?.accessAmount ?? 0) - 1)
                    .fill(0)
                    .map((_, i) => (
                      <Input
                        label={`Dependente ${i + 1}`}
                        name={`extraCpfs.${i}`}
                        mask="cpf"
                        control={control}
                        width={'100%'}
                        key={i}
                      />
                    ))}
              </VStack>
              {subscription?.plan?.accessAmount === 1 && (
                <Box
                  textAlign={'center'}
                  width={'100%'}
                  alignContent={'center'}
                  justifyContent={'center'}
                  alignItems={'center'}
                >
                  <ButtonC
                    isLoading={updateSubscriptionMutation.isLoading}
                    onClick={() => nav(`/perfil/planos`)}
                    color={colors?.primaryColor}
                    borderColor={colors?.primaryColor}
                    variant={'outline'}
                  >
                    Fazer Upgrade
                  </ButtonC>
                </Box>
              )}
              {subscription?.plan?.accessAmount !== 1 && (
                <Button
                  isLoading={updateSubscriptionMutation.isLoading}
                  onClick={() => updateSubscriptionMutation.mutate()}
                  marginTop={'10px'}
                  width={'100%'}
                >
                  Atualizar
                </Button>
              )}
            </form>
          </VStack>
        </VStack>
      </Grid>
    </VStack>
  );
}
